import api from './api';

export const getAllocationsForRecord = async (recordId) => {
    const res = await api.get(`/ProjectAllocation/record/${recordId}`);
    return res.data;
};

export const createAllocation = async (data) => {
    const res = await api.post('/ProjectAllocation', data);
    return res.data;
};

export const updateAllocation = async (id, data) => {
    const res = await api.patch(`/ProjectAllocation/${id}`, data);
    return res.data;
};

export const deleteAllocation = async (id) => {
    const res = await api.delete(`/ProjectAllocation/${id}`);
    return res.data;
};

export const getAllocationsByTicket = async (ticketId) => {
    const res = await api.get(`/ProjectAllocation/ticket/${ticketId}`);
    return res.data;
};

export const moveAllocations = async ({ allocation_ids, ticket_id }) => {
    const res = await api.post('/ProjectAllocation/move', { allocation_ids, ticket_id });
    return res.data;
};
